import React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

import { Row, Button, Popup, RecordSelect, DatePicker, Popconfirm, Loader, Select } from '@smartplatform/ui';
import store from '../../store';

export const positions = {
	0: 'член фракции',
	1: 'руководитель фракции',
	2: 'заместитель руководителя',
};

@observer
export default class ConvocationEdit extends React.Component {
	@observable convocation = null;
	@observable startDate = null;
	@observable endDate = null;
	@observable fraction = null;
	@observable division = null;
	@observable divisionGroup = null;
	@observable divisionText = '';
	@observable positionNum = null;
	@observable comment = '';
	@observable error = null;
	@observable isLoading = false;

	constructor(props) {
		super(props);
		this.init();
	}

	init = async () => {
		const { deputyConvocation } = this.props;
		if (deputyConvocation) {
			this.convocation = deputyConvocation.convocation;
			this.startDate = deputyConvocation.startDate;
			this.endDate = deputyConvocation.endDate;
			this.fraction = deputyConvocation.fraction;
			this.division = deputyConvocation.division;
			this.divisionGroup = deputyConvocation.divisionGroup;
			this.divisionText = deputyConvocation.divisionText;
			this.positionNum = deputyConvocation.fraction ? deputyConvocation.positionNum || 0 : null;
			this.comment = deputyConvocation.comment || '';
		}
	};

	onConvocationChange = record => (this.convocation = record);

	onFractionChange = record => {
		this.fraction = record;
		this.positionNum = record ? 0 : null;
	};

	onDivisionGroupChange = record => (this.divisionGroup = record);
	onStartDateChange = date => (this.startDate = date);
	onEndDateChange = date => (this.endDate = date);
	onCommentChange = e => (this.comment = e.target.value);
	onDivisionTextChange = e => (this.divisionText = e.target.value);
	onPositionNumChange = value => (this.positionNum = value);

	onDivisionChange = record => {
		this.division = record;
		if (record) this.divisionText = record.name;
	};

	save = async () => {
		if (!this.convocation) {
			this.error = 'Выберите созыв';
			return;
		}
		this.isLoading = true;
		const deputyConvocation = this.props.deputyConvocation || new store.model.DeputyConvocation();
		deputyConvocation.convocation = this.convocation;
		deputyConvocation.fraction = this.fraction;
		deputyConvocation.division = this.division;
		deputyConvocation.divisionGroup = this.divisionGroup;
		deputyConvocation.divisionText = this.divisionText;
		deputyConvocation.startDate = this.startDate;
		deputyConvocation.endDate = this.endDate;
		deputyConvocation.positionNum = this.positionNum;
		deputyConvocation.comment = this.comment || null;
		deputyConvocation.deputyId = this.props.deputy.id;
		await deputyConvocation.save();
		this.isLoading = false;
		this.props.onChange && this.props.onChange();
		this.props.onClose && this.props.onClose();
	};

	delete = async () => {
		await this.props.deputyConvocation.delete();
		this.props.onChange && this.props.onChange();
		this.props.onClose && this.props.onClose();
	};

	render() {
		return (
			<Popup onClose={this.props.onClose} width={700} height={500} scrollable={false}>
				<div className="form-field">
					<label>Созыв</label>
					<RecordSelect model={store.model.Convocation} property="name" value={this.convocation} onChange={this.onConvocationChange} />
				</div>
				<Row>
					<div className="form-field">
						<label>Фракция</label>
						<RecordSelect
							model={store.model.Fraction}
							property="shortName"
							value={this.fraction}
							filter={{ where: { existing: true } }}
							onChange={this.onFractionChange}
						/>
					</div>
					<div className="form-field">
						<label>Избирательный округ</label>
						<RecordSelect
							model={store.model.Division}
							property="name"
							value={this.division}
							searchFields={['name']}
							onChange={this.onDivisionChange}
						/>
					</div>
					<div className="form-field">
						<label>Региональная группа</label>
						<RecordSelect
							model={store.model.DivisionGroup}
							property="name"
							value={this.divisionGroup}
							searchFields={['name']}
							onChange={this.onDivisionGroupChange}
						/>
					</div>
				</Row>
				<Row>
					<div className="form-field">
						<label>Должность</label>
						<Select
							items={[
								{ label: positions[1], value: 1 },
								{ label: positions[2], value: 2 },
								{ label: positions[0], value: 0 },
							]}
							noSearch={true}
							value={this.positionNum}
							onChange={this.onPositionNumChange}
							disabled={!this.fraction}
						/>
					</div>
					<div className="form-field">
						<label>Начало полномочий</label>
						<DatePicker
							value={this.startDate}
							onChange={this.onStartDateChange}
							format="DD.MM.YYYY"
							showTimeSelect={false}
							showYearDropdown={true}
							showMonthDropdown={true}
						/>
					</div>
					<div className="form-field">
						<label>Конец полномочий</label>
						<DatePicker value={this.endDate} onChange={this.onEndDateChange} format="DD.MM.YYYY HH:mm" showTimeSelect={true} />
					</div>
				</Row>
				<div className="form-field">
					<label>Избирательный округ (текст, только для старых созывов)</label>
					<input type="text" value={this.divisionText || ''} onChange={this.onDivisionTextChange} />
				</div>
				<div className="form-field">
					<label>Комментарий</label>
					<textarea rows={5} value={this.comment || ''} onChange={this.onCommentChange} />
				</div>
				<div className="form-field">
					<Button onClick={this.save}>{this.props.deputyConvocation ? 'Сохранить' : 'Добавить'}</Button>
					{this.props.deputyConvocation && (
						<>
							&nbsp;{' '}
							<Popconfirm content="Удалить?" onConfirm={this.delete}>
								<FontAwesomeIcon icon={faTrash} className="delete-btn" />
							</Popconfirm>
						</>
					)}
					{this.isLoading && (
						<>
							&nbsp; <Loader />
						</>
					)}
				</div>
				{this.error && <div className="error">{this.error}</div>}
			</Popup>
		);
	}
}
